module.exports = __webpack_public_path__ + "static/img/empty.de4b22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty.png
// module id = OmQY
// module chunks = 1